export function username(user) {
    const firstname = user.role === 'teacher' ? initial(user.firstname) : user.firstname
    return  firstname + ' ' + user.middlename + ' ' + user.lastname
}

export function initial(name) {
    return firstLetter(name) + '.'
}

export function initials(user) {
    return [user.firstname, user.middlename, user.lastname].map(firstLetter).join('')
}

function firstLetter(name) {
    return name.charAt(0).toUpperCase()
}

function dateForTimestamp(timestamp, includeTime) {
    if ( timestamp == null ) {
        return ''
    }
    return date( new Date( timestamp * 1000 ), includeTime )
}

export function date(date, includeTime) {
    if ( date == null ) {
        return ''
    }

    if ( date === parseInt(date, 10) ) {
        return dateForTimestamp(date, includeTime)
    }

    const format = date.getDate() + ' / ' + (date.getMonth() + 1) + ' / '  + date.getFullYear();

    return includeTime ? format + ' ' + time(date) : format
}

function time(date) {
    const minutes = date.getMinutes()
    return date.getHours() + ':' + (minutes < 10 ? '0' : '') + minutes
}

export function sorter(key) {

    key = key || 'created_at'

    return (a, b) => {
        // note that this is sorted in reverse, newest first
        if (a[key] > b[key]) {
            return -1;
        }
        if (a[key] < b[key]) {
            return 1;
        }
        return 0

    }

}

export function excerpt(text, maxLength, tail) {

    tail = tail || '...'

    if ( text.length <= maxLength ) {
        return text
    }

    return text.substring(0, maxLength - tail.length) + tail

}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/transformers.js